<script lang="ts" context="module">
    export enum DrawerType {
    Navigation = 'navigation-drawer',
    FeatureFlag = 'feature-flag-drawer',
    ClientCreate = 'client-create-drawer',
    ClientEdit = 'client-edit-drawer',
    ClientDelete = 'client-delete-drawer',
    UserCreate = 'user-create-drawer',
    UserEdit = 'user-edit-drawer',
    IntegrationClients = 'integration-clients',
    DeleteAbortedClient = 'delete-aborted-client',
    LocalisationEdit = 'localisation-edit-drawer'
    }
</script>

<script lang="ts">
  import { Drawer, getDrawerStore } from '@skeletonlabs/skeleton';
  import Navbar from '$lib/components/navbar/Navbar.svelte';
  import { Cat } from 'phosphor-svelte';
  import FeatureFlagDrawer from '$lib/components/drawers/featureFlag/FeatureFlagDrawer.svelte';
  import EditClientDrawer from '$lib/components/drawers/client/edit/EditClientDrawer.svelte';
  import CreateClientDrawer from '$lib/components/drawers/client/create/CreateClientDrawer.svelte';
  import DeleteClientDrawer from '$lib/components/drawers/client/delete/DeleteClientDrawer.svelte';
  import EditUserDrawer from '$lib/components/drawers/client/edit/EditClientDrawer.svelte';
  import CreateUserDrawer from '$lib/components/drawers/client/create/CreateClientDrawer.svelte';
  import IntegrationTypeDrawer from '$lib/components/drawers/integrations/IntegrationTypeDrawer.svelte';
  import DeleteAbortedClientDrawer from '$lib/components/drawers/integrations/DeleteAbortedClientDrawer.svelte';
  import LocalisationDrawer from "$lib/components/drawers/localisation/LocalisationDrawer.svelte";

    const drawerStore = getDrawerStore();

    $: id = $drawerStore.id;
    $: meta = $drawerStore.meta;
</script>

<Drawer>
  {#if id === DrawerType.Navigation}
    <h2 class="p-4 text-xl font-medium text-primary-500">Navigation</h2>
    <hr />
    <Navbar />
  {:else if id === DrawerType.FeatureFlag}
    <FeatureFlagDrawer name={meta.name} dataHandler={meta.dataHandler} />
  {:else if id === DrawerType.ClientEdit}
    <EditClientDrawer id={meta.id} dataHandler={meta.dataHandler} />
  {:else if id === DrawerType.ClientCreate}
    <CreateClientDrawer dataHandler={meta.dataHandler} />
  {:else if id === DrawerType.ClientDelete}
    <DeleteClientDrawer id={meta.id} dataHandler={meta.dataHandler} />
  {:else if id === DrawerType.UserEdit}
    <EditUserDrawer id={meta.id} dataHandler={meta.dataHandler} />
  {:else if id === DrawerType.UserCreate}
    <CreateUserDrawer dataHandler={meta.dataHandler} />
  {:else if id === DrawerType.IntegrationClients}
    <IntegrationTypeDrawer integration={meta.integration} />
  {:else if id === DrawerType.DeleteAbortedClient}
    <DeleteAbortedClientDrawer deleteAbortedClient={meta.deleteAbortedClient} />
  {:else if id === DrawerType.LocalisationEdit}
    <LocalisationDrawer />
  {:else}
    <div class="h-full content-center">
      <Cat weight="duotone" size="100" class="m-auto" />
      <div class="text-center">"Meow" - Cat, 2024</div>
    </div>
  {/if}
</Drawer>
